module.exports = __webpack_public_path__ + "img/dl.ba5600e0.png";